export const Constants = {
    emptyString: "",
    maxAllowedInt32: 2147483646, // 2147483647 is the max value for int32 but doesn't work in some cases
    zero: 0,
    startIndex: 0,
    secondIndex: 1,
    thirdIndex: 2,
};
